import { PartnerSetting } from "./defaults";
import SETTINGS_CTL_DATA from "./ctlWebchat.json";

const SETTINGS_CTL = SETTINGS_CTL_DATA as PartnerSetting;
export default SETTINGS_CTL;
